<template>
  <div>
    <SmartTitle class="mb-4 title-chip" heading="1" weight="medium"
      >Timelife do Chip</SmartTitle
    >
    <label for="search"
      >Para fazer uma pesquisa, digite o ICCID completo.</label
    >
    <div
      class="
        main__wrapper
        bg-white
        flex
        align-center
        justify-around
        flex-row
        relative
      "
    >
      <div class="my-4 form-area">
        <form class="flex justify-between align-center">
          <div class="spacing-input-search">
            <div class="flex justify-end">
              <v-text-field
                v-model="search"
                label="Buscar por ICCID"
                single-line
                hide-details
                mask="####################"
                type="tel"
                name="search"
              />
              <button
                @click.prevent="findByIccid"
                class="
                  flex
                  my-1
                  align-center
                  justify-center
                  cursor-pointer
                  rounded
                  absolute
                  bg-brand-secondary
                "
                style="width: 120px; height: 40px; color: white"
              >
                <SmartIcon
                  :size="2"
                  name="search"
                  color="white"
                  style="margin-right: 8px"
                />
                Buscar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="!loading">
      <VDataTable
        v-if="chipTable"
        :headers="headers"
        :items="newList"
        :must-sort="true"
        hide-actions
        no-data-text="Não há dados a serem exibidos"
        item-key
        class="my-4"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.iccid }}</td>
          <td>{{ props.item.billing_date || "-" }}</td>
          <td>{{ props.item.date_db || "-" }}</td>
          <td>{{ props.item.date_saller || "-" }}</td>
          <td>{{ props.item.date_place || "-" }}</td>
          <td>{{ props.item.date_activation || "-" }}</td>
          <td>{{ props.item.date_recharge || "-" }}</td>
          <td>{{ props.item.transactions_status || "-" }}</td>
          <td>{{ props.item.view || "-" }}</td>
          <td class="view-icon" width="100">
            <label
              @click="showInfo(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="view" class="mr-1-2" />
            </label>
          </td>
        </template>
      </VDataTable>
      <div class="flex justify-center">
        <v-pagination
          v-if="currentPage"
          v-model="pagination.page"
          @input="changePage"
          :length="length"
          :value="currentPage"
          :total-visible="7"
          circle
        />
      </div>
    </div>
    <SmartCard class="mt-4 p-3" v-if="skeleton">
      <SmartSkeletonLoading :items="11" :height="4" />
    </SmartCard>
    <div>
      <SmartDrawer
        @close="
          () => {
            showDrawer = false;
            chip = null;
          }
        "
        :show="showDrawer"
      >
        <template v-slot:header>
          <SmartTitle class="text-brand-secondary" weight="regular"
            >Detalhes do Chip</SmartTitle
          >
        </template>
        <InfoChip v-if="chip" :chip="chip" />
      </SmartDrawer>
    </div>
    <SmartModal v-if="modal" v-bind="modal" @close="modal = null"
      >{{ modal.text }}
    </SmartModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatBRDate, formatUSDate } from "utils/date";

export default {
  name: "ListChip",
  components: {
    InfoChip: () => import("./InfoChip"),
  },
  data() {
    return {
      findListEmpty: false,
      chipTable: false,
      skeleton: false,
      modal: null,
      loading: false,
      search: "",
      chip: null,
      isAbleToSearch: false,
      statusSubmit: "",
      recharge: ["Sim", "Não"],
      rechargeSubmit: "",
      data_from_create: "",
      data_to_create: "",
      data_from_DB: "",
      data_to_DB: "",
      data_from_sale: "",
      data_to_sale: "",
      data_from_activation: "",
      data_to_activation: "",
      showDrawer: false,
      currentPage: "",
      pagination: {
        rowsPerPage: 10,
        page: 1,
      },
      headers: [
        { text: "ICCID", value: "iccid", sortable: false },
        { text: "Faturamento", value: "billing_date", sortable: false },
        { text: "Distribuidor", value: "date_db", sortable: false },
        { text: "Vendedor", value: "date_saller", sortable: false },
        { text: "Ponto de Venda", value: "date_place", sortable: false },
        { text: "Ativação", value: "date_activation", sortable: false },
        { text: "Recarga", value: "date_recharge", sortable: false },
        { text: "Status", value: "transactions_status", sortable: false },
        { text: "Regional", value: "view", sortable: false },
        { text: "Detalhes", value: "details", sortable: false },
      ],
    };
  },
  watch: {
    search(search) {
      if (search.length === 20) {
        this.isAbleToSearch = true;
      } else {
        this.isAbleToSearch = false;
      }
    },
    simcardPagination(item) {
      if (this.simcardPagination && this.simcardPagination.current_page) {
        this.pagination.page = Number(item.current_page);
      }
    },
  },
  computed: {
    ...mapGetters({
      simcardList: "chip/simcardList",
      simcardPagination: "chip/pagination",
    }),
    newList(){
      return this.chipList.length > 0 ? this.chipList : this.simcardList;
    },
    length() {
      return this.simcardPagination && this.simcardPagination.last_page;
    },
    chipList() {
      return (
        (this.simcardList &&
        this.simcardList.map((chip) => ({
            id: chip ? chip.id : "-",
            iccid: chip ? chip.iccid : "-",
            billing_date: chip ? formatBRDate(chip.data_criacao) : "-",
            date_db: chip ? formatBRDate(chip.data_db) : "-",
            date_saller: chip ? formatBRDate(chip.data_vendedor) : "-",
            date_place: chip ? formatBRDate(chip.data_pdv) : "-",
            date_activation: chip ? formatBRDate(chip.data_ativacao) : "-",
            date_recharge: chip ? formatBRDate(chip.data_1_recarga) : "-",
            transactions_status: chip ? chip.status : "-",
            view: chip ? chip.regional : "-",
          }))) ||
        []
      );
    },
  },
  methods: {
    ...mapActions({
      fetchsimcardList: "chip/fetchsimcardList",
      fetchsimcardListWithFilter: "chip/fetchsimcardListWithFilter",
      fetchsimcardByIccid: "chip/fetchsimcardByIccid",
    }),
    findByIccid() {
      this.chipTable = false;

      const search = this.search.replace(/[.-]/g, "");

      this.skeleton = true;
      this.loading = true;
      this.currentPage = null;

      this.fetchsimcardByIccid(search)
        .catch(({ data }) => {

          this.showErrorModal({ data });

          this.skeleton = true;
          this.loading = true;
          this.chipTable = false;
          this.search = "";
        })
        .finally(() => {
          this.skeleton = false;
          this.loading = false;
          this.chipTable = true;
        });
    },
    showErrorModal({ data }) {
      this.modal = {
        type: "warning",
        title: "Ops!",
        icon: "alert",
        buttonText: "Tentar novamente",
        text: data.message || "Um erro desconhecido ocorreu",
      };
    },
    close() {
      this.filterModal = false;
    },
    changePage(page) {
      // if (this.hasSomeFilter) {
      //   this.loading = true;
      //   return this.fetchsimcardListWithFilter({
      //     filter: this.filter(),
      //     page: this.pagination.page,
      //   }).then(() => {
      //     this.loading = false;
      //   });
      // }
      // return this.fetchsimcardList({ page, sort: this.currentSort }).then(
      //   () => {
      //     this.loading = false;
      //   }
      // );
    },
    async sort(sortable) {
      this.currentSort = {
        order: sortable.descending ? "desc" : "asc",
        sort: sortable.sortBy,
      };

      this.loading = true;
      this.callWhenHasNoFilter();
      this.loading = false;
    },
    callWhenHasNoFilter() {
      return this.fetchsimcardList({
        page: this.pagination.page,
        sort: this.currentSort,
      });
    },
    showInfo(id) {
      const tempChip = this.simcardList.find((chip) => chip.id === id);
      this.chip = {
        id: tempChip.id,
        iccid: tempChip.iccid,
        pdv_name: tempChip.pdv_name,
        distributor_name: tempChip.db_slug,
        created_at: formatBRDate(tempChip.data_criacao),
        date_db: formatBRDate(tempChip.data_db),
        id_pdv: tempChip.place_id,
        id_pdv_db: tempChip.id_pdv_db,
        date_place: formatBRDate(tempChip.data_pdv),
        activate_date: formatBRDate(tempChip.data_ativacao),
        status: tempChip.status
      };
      this.showDrawer = true;
    }
  }
};
</script>

<style lang="scss">
.v-input__control .v-input__slot .v-text-field__slot input {
  width: 270px;
}
.filter-modal {
  right: $spacing-margin-medium;
  box-shadow: $box-shadow-sm;
  z-index: 1;
}

.fix-right-on-filter-modal {
  right: inherit !important;
}

.main__wrapper {
  padding: 15px 15px 15px 15px;
  border: 1px solid #e3e5e6;
  border-radius: 6px;
  height: 70px;
  z-index: 1;
  margin-top: 20px;
}

.spacing-input-search {
  max-width: 100% !important;
  width: 100% !important;
}

.form-area {
  width: 100%;
}

.title-chip {
  margin-left: 0rem;
}
</style>
